import { mapGetters,  mapActions} from 'vuex'

export default {
  name: 'AccountBox',
  computed: {
    ...mapGetters({
      userName: 'auth/userName',
      roleName: 'auth/roleName'
    }),
    showNavi () {
      return this.authorized
    }
  },
  methods: {
    ...mapActions({
      signout: 'auth/signout'
    }),
    clickSignOut () {
      this.signout()
        .then(() => {
          this.$router.push({
            name: 'Signin'
          })
        })
    }
  }
}